// removed by extract-text-webpack-plugin
module.exports = {"loading-icon":"index-module__loading-icon___2ZlYm","loadingIcon":"index-module__loading-icon___2ZlYm"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/common/button/index.module.scss
// module id = 1439
// module chunks = 147